import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=43cd4cbf&"
import script from "./Wait.vue?vue&type=script&lang=js&"
export * from "./Wait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports